/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/16/20
 * Copyright All Rights Reserved
 */
// @flow
import classNames from 'classnames';
import * as React from 'react';
import { Button, Row } from 'reactstrap';
import { actionRow, actionRowButton } from './index.module.scss';

type ActionRowProps = {
  children: React.Node,
  className?: string,
}

export const ActionRow = ({ children, className, ...rest }: ActionRowProps) => (
  <Row {...rest} className={classNames(actionRow, className)}>
    {children}
  </Row>
);

ActionRow.defaultProps = {
  className: '',
};


type ActionRowLinkProps = {
   children: React.Node,
   className?: string,
};

export const ActionRowButton = ({ children, className, ...rest }: ActionRowLinkProps) => (
  <Button
    {...rest}
    color="link"
    className={classNames(actionRowButton, className)}
  >
    {children}
  </Button>
);

ActionRowButton.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./js/components/support/layout/ActionRow/index.jsx